"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalFormArrays = require("react-final-form-arrays");
var _reactFinalForm = require("react-final-form");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _EditableSettingsListFieldArray = _interopRequireDefault(require("./EditableSettingsListFieldArray"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditableSettingsList = _ref => {
  let {
    allowEdit = true,
    // A gloabal boolean permission to turn on/off editing of all appSettings in the frontend
    data,
    initialValues,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    label,
    labelOverrides = {},
    onSave,
    render // Experimental idea, allow unique rendering per setting?
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Form, {
    enableReinitialize: true,
    initialValues: initialValues,
    keepDirtyOnReinitialize: true,
    mutators: _finalFormArrays.default,
    navigationCheck: true,
    onSubmit: onSave,
    subscription: {
      value: true
    },
    children: _ref2 => {
      let {
        handleSubmit
      } = _ref2;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalFormArrays.FieldArray, {
          allowEdit: allowEdit,
          component: _EditableSettingsListFieldArray.default,
          data: data,
          intlKey: passedIntlKey,
          intlNS: passedIntlNS,
          label: label,
          labelOverrides: labelOverrides,
          name: "settings",
          onSave: onSave,
          render: render
        })
      });
    }
  });
};
EditableSettingsList.propTypes = {
  allowEdit: _propTypes.default.bool,
  data: _propTypes.default.shape({
    refdatavalues: _propTypes.default.arrayOf(_propTypes.default.object)
  }),
  initialValues: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
  labelOverrides: _propTypes.default.object,
  onSave: _propTypes.default.func
};
var _default = exports.default = EditableSettingsList;